import { createContext } from 'react';

export const MapStyleFormContext = createContext();

export const createMapStyleFormProps = ({
  basemap,
  heatmapGradient,
  heatmapContrast,
  heatmapVisibility,
  aggregates,
  shapeBorderColor,
  shapeBorderWidth,
  visualizationType,
  aggregatableFields,
  heatmapWeightField,
}) => ({
  basemap,
  heatmapGradient,
  heatmapContrast,
  heatmapVisibility,
  aggregates,
  shapeBorderColor,
  shapeBorderWidth,
  visualizationType,
  aggregatableFields,
  heatmapWeightField,
});
